import { useMemo } from 'react';
import { useRouter } from 'next/router';
import Select, { ISelectOption } from '@creditflowresearch/uilib/Select';
import { ITabSubtypeItem } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/ITabItem';
import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';
import { getQueryString, removeQueryParams } from '@framework/router';
import { getFormatUrl } from '@/creditflowresearch/ui/common/helpers';

interface IArticlesTabSelectProps {
  tabs: ITabSubtypeItem[],
  basePath: string,
}

const ArticlesTabSelect = ({ tabs, basePath }: IArticlesTabSelectProps) => {
  const { query: routeParams, push, asPath } = useRouter();
  const query = useMemo<IQueryParams>(
    () => removeQueryParams(routeParams as IQueryParams, ['productType', 'articleType']),
    [routeParams],
  );

  const options: ISelectOption[] = tabs.map((tab) => ({ label: tab.label, value: tab.key }));
  const selectedOption = options.find((opt) => {
    const tab = tabs.find((t) => t.key === opt.value);
    return tab && asPath.includes(`${ basePath }${ tab.url }`);
  }) || options[0];

  const handleChange = (option: ISelectOption): void => {
    const tab = tabs.find((t) => t.key === option.value);
    if (tab) {
      push(getFormatUrl(`${ basePath }${ tab.url }?${ getQueryString(query) }`));
    }
  };

  return (
    <Select
      value={ selectedOption }
      options={ options }
      onChange={ handleChange }
      isSlim
      isNarrow
      isSearchable={ false }
      dataTest="articlesSubtypeTabSelect"
      size="S"
    />
  );
};

export default ArticlesTabSelect;
